import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { isMarketingMockEnabled } from './is-marketing-mock-enabled';

const MOCK_DISPLAY_NAME = 'Ana Silva';

/** Ajusta nome exibido na sidebar para screenshots comerciais. */
export function useMarketingMockAuth() {
  useEffect(() => {
    if (!isMarketingMockEnabled()) return;

    const { user, setUser } = useAuthStore.getState();
    if (!user || user.username === MOCK_DISPLAY_NAME) return;

    setUser({ ...user, username: MOCK_DISPLAY_NAME });
  }, []);
}
